import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import { Chip, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { getIntlLocale } from '@/shared/i18n';

import { formatDayLong } from './format';

export interface EpisodeDividerProps {
  /** The episode's `startedAt`, or (when the episode isn't loaded) the group's first message time. */
  startedAt: string;
  topic?: string | null;
  /** Highlights the CURRENT episode's divider and appends "current" to its accessible name. */
  current?: boolean;
}

/** "⚑ Episode started 9 September · Refund for order 1002" — groups the timeline by episode (§11.1). */
export function EpisodeDivider({ startedAt, topic, current = false }: EpisodeDividerProps) {
  const { t } = useTranslation('conversations');
  const date = formatDayLong(startedAt, getIntlLocale());
  const text = topic
    ? t('timeline.episodeStarted', { date, topic })
    : t('timeline.episodeStartedNoTopic', { date });
  const accessibleLabel = current ? `${text} — ${t('timeline.episodeCurrent')}` : text;

  return (
    <Divider textAlign="left" role="separator" aria-label={accessibleLabel} sx={{ my: 1.5 }}>
      <Chip
        size="small"
        variant="outlined"
        color={current ? 'primary' : 'default'}
        icon={<FlagRoundedIcon fontSize="inherit" />}
        label={text}
      />
    </Divider>
  );
}
